import React from 'react';
import { BONUS_INTRO, BONUSES, PRICE } from '../constants/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function BonusSection() {
  return <section className="w-full bg-cream py-12 b760:py-16" data-id="element-28" data-mp="22fd555ybvsuu">
      <div className="mx-auto max-w-3xl px-4 b720:px-6" data-id="element-29" data-mp="22etxci2e6kuj">
        <Reveal className="text-center" data-id="element-30" data-mp="1ydryi2ce0at3">
          <span className="inline-block rounded-full bg-bordo px-4 py-1.5 text-xs font-700 uppercase tracking-wide text-mustard b640:text-sm" data-id="element-31" data-mp="1yetcaeksfbei">
            {BONUS_INTRO.badge}
          </span>
          <h2 className="mt-4 font-display text-2xl font-700 uppercase leading-tight text-night b640:text-4xl" data-id="element-32" data-mp="15r77x43qk2ql">
            {BONUS_INTRO.title}
          </h2>
          <p className="mt-3 text-sm text-night/75 b640:text-base" data-id="element-33" data-mp="1epsl0jqfupjz">
            {BONUS_INTRO.sub}
          </p>
        </Reveal>

        <div className="mt-8 space-y-4" data-id="element-34" data-mp="qywxhyt0mgij">
          {BONUSES.map((bonus, index) => <Reveal key={bonus.n} delay={index * 40} data-id="element-35" data-mp="my3ad7ned5qp" data-mpi={index}>
              <article className="flex gap-4 rounded-2xl border border-night/10 bg-white p-4 b640:p-5" data-id="element-36" data-mp="29s30xa4thh92">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-bordo font-display text-base font-700 text-mustard" data-id="element-37" data-mp="2eqwfz6zr5gbc">
                  #{bonus.n}
                </span>
                <div className="min-w-0" data-id="element-38" data-mp="2ogpp81cf9jcf">
                  <span className="text-[11px] font-700 uppercase tracking-wide text-bordo b640:text-xs" data-id="element-39" data-mp="2ogg0si70zk8u">
                    Bono #{bonus.n}
                  </span>
                  <h3 className="mt-0.5 font-display text-lg font-700 leading-tight text-night b640:text-xl" data-id="element-40" data-mp="1vriiif2tdng3">
                    {bonus.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-night/80" data-id="element-41" data-mp="20trb3abrynho">
                    {bonus.desc}
                  </p>
                  <p className="mt-3 inline-flex flex-wrap items-center gap-1.5 rounded-lg bg-cream px-3 py-1.5 text-xs font-700 text-night/80" data-id="element-42" data-mp="3c7d2l253x16d">
                    <span aria-hidden="true" data-id="element-43" data-mp="3h3tso1vv9pm3">✓</span>
                    <span data-id="element-44" data-mp="1h2m3vbjnvpyl">Valor regular</span>
                    <span className="font-display text-sm text-bordo line-through" data-id="element-45" data-mp="1h5i10xnoqalz">
                      {bonus.value}
                    </span>
                    <span data-id="element-46" data-mp="1q4lhruzdqdxb">— gratis para vos</span>
                  </p>
                </div>
              </article>
            </Reveal>)}
        </div>

        <Reveal className="mt-8" data-id="element-47" data-mp="1m0nkzqxj1f7f">
          <div className="rounded-2xl border-2 border-mustard bg-bordo px-5 py-6 text-center text-cream" data-id="element-48" data-mp="yce515mzvlo7">
            <p className="text-xs font-600 uppercase tracking-wide text-cream/80 b640:text-sm" data-id="element-49" data-mp="tem2lhoq4h5r">
              {BONUS_INTRO.totalLabel}
            </p>
            <p className="mt-1 font-display text-4xl font-700 text-mustard b640:text-5xl" data-id="element-50" data-mp="177c12llfvejr">
              {PRICE.bonusesTotal}
            </p>
            <p className="mt-2 text-xs text-cream/75 b640:text-sm" data-id="element-51" data-mp="eoev1x098iju">
              {BONUS_INTRO.totalNote}
            </p>
          </div>
        </Reveal>

        <Reveal className="mx-auto mt-8 max-w-md" data-id="element-52" data-mp="al8nmm1eolbs">
          <CtaButton data-id="element-53" data-mp="j4mzy2av0hc">{BONUS_INTRO.cta}</CtaButton>
          <p className="mt-2 text-center text-xs text-night/60 b640:text-sm" data-id="element-54" data-mp="hbk8tut50em">
            {BONUS_INTRO.ctaSub}
          </p>
        </Reveal>
      </div>
    </section>;
}